import { EditorComponent } from './editor/editor.component';
import { PrintProjectSummaryComponent } from './print-project-summary/print-project-summary.component';
import { WhereBuyComponent } from './where-buy/where-buy.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { FinishedProjectComponent } from './finished-project/finished-project.component';
import { Questionnaire4Component } from './questionnaire4/questionnaire4.component';
import { QuestionnaireSummaryComponent } from './questionnaire-summary/questionnaire-summary.component';
import { Questionnaire3Component } from './questionnaire3/questionnaire3.component';
import { Questionnaire2Component } from './questionnaire2/questionnaire2.component';
import { Questionnaire1Component } from './questionnaire1/questionnaire1.component';
import { WhatPlasterComponent } from './what-plaster/what-plaster.component';
import { ComposeColorSetComponent } from './compose-color-set/compose-color-set.component';
import { ChoosePaletteComponent } from './choose-palette/choose-palette.component';
import { PalettesInfoComponent } from './palettes-info/palettes-info.component';
import { ChooseProjectComponent } from './choose-project/choose-project.component';
import { StartProjectComponent } from './start-project/start-project.component';
import { HowChooseColorComponent } from './how-choose-color/how-choose-color.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectSummaryComponent } from './project-summary/project-summary.component';
import { SelectMosaicComponent } from './select-mosaic/select-mosaic.component';
import { MyProjectsComponent } from './my-projects/my-projects.component';
import { HelpComponent } from './help/help.component';
import { UserStartProjectComponent } from './user-start-project/user-start-project.component';

const routes: Routes = [
  { path: '', component: HomeComponent},
  { path: 'how-choose-color', component: HowChooseColorComponent},
  { path: 'start-project', component: StartProjectComponent},
  { path: 'choose-project', component: ChooseProjectComponent},
  { path: 'choose-palette/:type', component: ChoosePaletteComponent},
  { path: 'palettes-info/:type', component: PalettesInfoComponent},
  { path: 'compose-color-set/:type/:palette', component: ComposeColorSetComponent},
  { path: 'what-plaster', component: WhatPlasterComponent},
  { path: 'questionnaire1', component: Questionnaire1Component},
  { path: 'questionnaire2', component: Questionnaire2Component},
  { path: 'questionnaire3', component: Questionnaire3Component},
  { path: 'questionnaire4', component: Questionnaire4Component},
  { path: 'questionnaire-summary', component: QuestionnaireSummaryComponent},
  { path: 'finished-project', component: FinishedProjectComponent},
  { path: 'calculator', component: CalculatorComponent},
  { path: 'where-buy', component: WhereBuyComponent},
  { path: 'project-summary', component: ProjectSummaryComponent},
  { path: 'print-project-summary', component: PrintProjectSummaryComponent},
  { path: 'select-mosaic', component: SelectMosaicComponent},
  { path: 'help', component: HelpComponent},
  { path: 'my-projects', component: MyProjectsComponent},
  { path: 'my-projects/:from', component: MyProjectsComponent},
  { path: 'editor', component: EditorComponent},
  { path: 'user-start-project', component: UserStartProjectComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Add options right here
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
